"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconAccordion = void 0;
var React = require("react");
// Duplicate component from plugin dashboard folder, as cross folder imports break Jenkins build
var FalconAccordion = /** @class */ (function (_super) {
    __extends(FalconAccordion, _super);
    function FalconAccordion(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.renderIfTop = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { onClick: _this.toggle, tabIndex: 0, onKeyPress: _this.toggle }, _this.state.isShown ? _this.props.toggleShown : _this.props.toggleHidden),
                _this.state.isShown && React.createElement("div", { className: "falcon-accordion-content" }, _this.props.children)));
        };
        _this.renderIfBottom = function () {
            return (React.createElement(React.Fragment, null,
                _this.state.isShown && React.createElement("div", { className: "falcon-accordion-content" }, _this.props.children),
                React.createElement("div", { onClick: _this.toggle }, _this.state.isShown ? _this.props.toggleShown : _this.props.toggleHidden)));
        };
        _this.toggle = function () {
            _this.setState({ isShown: !_this.state.isShown });
            if (_this.props.executeEvent) {
                _this.props.executeEvent();
            }
        };
        _this.state = {
            isShown: (_a = _this.props.isShown) !== null && _a !== void 0 ? _a : false
        };
        return _this;
    }
    FalconAccordion.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            var _a;
            _this.setState({ isShown: (_a = _this.props.isShown) !== null && _a !== void 0 ? _a : false });
        }, 800);
    };
    FalconAccordion.prototype.render = function () {
        return (React.createElement("div", { className: "falcon-accordion ".concat(this.props.className, " ").concat(this.state.isShown ? this.props.isShownClassName : "") }, this.props.togglePositionTop ? this.renderIfTop() : this.renderIfBottom()));
    };
    return FalconAccordion;
}(React.Component));
exports.FalconAccordion = FalconAccordion;
//# sourceMappingURL=FalconAccordionPlugin.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/FalconAccordionPlugin.js
// module id = 301
// module chunks = 0